module.exports = __webpack_public_path__ + "static/img/battery.737ed14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/battery.png
// module id = fXzd
// module chunks = 1